// shadcn/ui's Radix Checkbox composition, adapted to Valid Labels tokens.
// https://ui.shadcn.com/docs/components/radix/checkbox
import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check, Minus } from "lucide-react";
import { cn } from "../../lib/utils";

export const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, checked, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn("vl-checkbox", className)}
    checked={checked}
    {...props}
  >
    <CheckboxPrimitive.Indicator className="vl-checkbox-indicator">
      {checked === "indeterminate" ? (
        <Minus aria-hidden="true" size={12} strokeWidth={3} />
      ) : (
        <Check aria-hidden="true" size={12} strokeWidth={3} />
      )}
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = "Checkbox";
